<template>
  <div class="container">
    <div class="box">
      <div class="title">✔提交成功</div>
      <div class="content">您得更改申请已成功提交，请等待上级审核</div>
      <div>
        <el-button size="mini" @click="goon" type="success">继续留在该单位</el-button>
        <el-button size="mini" @click="back" type="warning">返回单位管理</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    goon () {
      // let controlId = this.$store.state.controlId
      // if (controlId === 101 || controlId === 102 || controlId === 103) {
      //   this.$router.push('/company/companyinfo')
      // } else {
      //   this.$router.push('/company/industry')
      // }
      this.$router.push('/company/companyinfo')
    },
    back () {
      this.$router.push('/project/enterprise')
    }
  }
}
</script>

<style scoped>
  .container {
    position: relative;
    height: 100vh;
  }
  .box {
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translate(-50%,-50%);
    text-align: center;
  }
  .box .title {
    color: #5190fb;
    font-size: 30px;
    text-align: center;
    margin-bottom: 5px;
  }
  .box .content {
    color: #666;
    font-size: 14px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/frame/Success.vue